import React, { useEffect, useState } from "react";
import SidebarBlog from "../components/blog/sidebar-blog";
import Layout from "../components/layout/layout";
import blogService from "../services/blogService";
import { useSelector } from "react-redux";
import ManageBlog from "../components/blog/manage-blog";
import SearchBlog from "../components/blog/search-blog";

const ManageBlogPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [filteredBlogs, setFilteredBlogs] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("approved"); // 'approved' or 'pending'
  const { userInfo } = useSelector((state) => state.user);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        setLoading(true);
        const data = await blogService.getActiveAndInactiveBlogs();
        setBlogs(data);
        setFilteredBlogs(data.filter((blog) => blog.status === 1)); // Mặc định hiển thị blog đã duyệt (status = 1)
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };
    fetchBlogs();
  }, []);

  // Handle search query changes
  useEffect(() => {
    const filtered = blogs.filter((blog) =>
      `${blog.name}`.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredBlogs(filtered);
  }, [searchQuery, blogs]);

  // Handle tab changes
  useEffect(() => {
    if (activeTab === "approved") {
      setFilteredBlogs(blogs.filter((blog) => blog.status === 1));
    } else {
      setFilteredBlogs(blogs.filter((blog) => blog.status !== 1));
    }
  }, [activeTab, blogs]);

  const handleBlogStatusToggle = (blogId, newStatus) => {
    setBlogs((prev) =>
      prev.map((blog) =>
        blog.id === blogId ? { ...blog, status: newStatus } : blog
      )
    );
    setFilteredBlogs((prev) =>
      prev.map((blog) =>
        blog.id === blogId ? { ...blog, status: newStatus } : blog
      )
    );
  };

  return (
    <Layout>
      <div className="content">
        <div className="container">
          <div className="row justify-content-end">
            <SearchBlog setSearchQuery={setSearchQuery} />
            <ManageBlog
              blogs={filteredBlogs}
              loading={loading}
              error={error}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              onStatusToggle={handleBlogStatusToggle}
            />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ManageBlogPage;
